import React from 'react';
import { Stack } from '@fiverr-private/layout_components';

interface GifWrapperProps extends React.ComponentProps<typeof Stack> {}

export const GifWrapper = ({ children, ...props }: React.PropsWithChildren<GifWrapperProps>) => (
    <Stack
        overflow="hidden"
        borderRadius="lg"
        width="min-content"
        height="min-content"
        borderWidth="sm"
        borderColor="grey_400"
        {...props}
    >
        {children}
    </Stack>
);
